import { EBrandKitTabs } from 'constants/enums';
import { AnimatePresence, motion } from 'framer-motion';
import { X } from 'lucide-react';
import { useTemplateStudioState } from 'state/hooks/template-studio.hook';

import SwitchSelector from 'components/SwitchSelector/SwitchSelector';
import { Sidebar, SidebarContent, SidebarHeader } from 'components/ui/sidebar';

import { BrandingForm } from './BrandingForm';
import { ExternalButtonsForm } from './ExternalButtonsForm';

export const BRAND_KIT_WIDTH = 318;

export const TemplateStudioBrandKitContainer: React.FC = () => {
  const { isBrandKitOpen, setIsBrandKitOpen, brandKitTab, setBrandKitTab } =
    useTemplateStudioState();

  const onClickSwitch = (value: string) => {
    setBrandKitTab(value as EBrandKitTabs);
  };

  const switchOptions = [
    { value: EBrandKitTabs.BRANDING },
    { value: EBrandKitTabs.EXTERNAL_BUTTONS }
  ];

  return (
    <AnimatePresence initial={true}>
      {isBrandKitOpen && (
        <motion.div
          key="brand-kit"
          initial={{ width: 0, maxWidth: 0 }}
          animate={{ width: BRAND_KIT_WIDTH, maxWidth: BRAND_KIT_WIDTH }}
          exit={{ width: 0, maxWidth: 0 }}
          transition={{
            duration: 0.18,
            ease: [0.22, 1, 0.36, 1],
            delay: 0
          }}
          style={{ overflow: 'hidden', minWidth: 0 }}
        >
          <motion.div
            initial={{ x: '100%', opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: '100%', opacity: 0 }}
            transition={{ duration: 0.18, ease: [0.4, 0, 0.2, 1] }}
            style={{ height: '100%', minWidth: BRAND_KIT_WIDTH }}
          >
            <Sidebar
              className="w-[318px] max-w-[318px] h-full box-content"
              side="right"
            >
              <SidebarHeader className="flex flex-row items-center justify-between p-0 mb-5">
                <p className="text-p-m font-semibold text-base-foreground">
                  Brand Kit
                </p>
                <X
                  size={16}
                  className="cursor-pointer"
                  onClick={() => setIsBrandKitOpen(false)}
                  data-testid="TemplatesStudio-BrandKit-close"
                />
              </SidebarHeader>
              <SwitchSelector
                options={switchOptions}
                onClick={onClickSwitch}
                value={brandKitTab}
                data-testid-prefix="TemplatesStudio-BrandKit-tab"
              />
              <SidebarContent className="px-2">
                {brandKitTab === EBrandKitTabs.BRANDING ? (
                  <BrandingForm />
                ) : (
                  <ExternalButtonsForm />
                )}
              </SidebarContent>
            </Sidebar>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
